function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["method", "payload", "params", "headers"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import axios from 'axios';
import { isEmpty } from '..';
// import refreshToken from './refresh_token';

var url = process.env.REACT_APP_API_URL;
// const url = 'http://localhost:7500';

// Default config options
var defaultOptions = {
  baseURL: url,
  'Content-Type': 'application/json',
  headers: {},
  timedOut: 3000
};

// Create instance
var instance = axios.create(defaultOptions);

// Add a request interceptor
instance.interceptors.request.use(function (request) {
  var userToken = sessionStorage.getItem('token');
  request.headers.Authorization = "Bearer ".concat(userToken);
  return request;
}, function (error) {
  return Promise.reject(error);
});

// Add a response interceptor
// instance.interceptors.response.use(
//   response => response.data,
//   async error => {
//     const config = error?.config;
//     if (error?.response) {
//       if (error.response?.status === 401 && !config._retry) {
//         config._retry = true;
//
//         const result = await refreshToken();
//
//         if (result) {
//           config.headers = {
//             ...config.headers,
//             Authorization: `Bearer ${result}`,
//           };
//         }
//
//         return axios(config);
//       }
//       if (error.code === 'ECONNABORTED')
//         throw new Error('Network timeout, please try again');
//       // The request was made and the server responded with a status code
//       // that falls out of the range of 2xx
//       return Promise.reject(error);
//     } else if (error.request) {
//       // The request was made but no response was received
//       // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//       // http.ClientRequest in node.js
//       error.message =
//         'This request is taking too long, please check your network';
//       throw error;
//     } else {
//       // Something happened in setting up the request that triggered an Error
//       throw error;
//     }
//   }
// );

export default instance;
export var createRequest = function createRequest(config) {
  return instance(config);
};
export var composeRequestConfig = function composeRequestConfig(config) {
  var _config$method = config.method,
    method = _config$method === void 0 ? 'get' : _config$method,
    payload = config.payload,
    params = config.params,
    headers = config.headers,
    rest = _objectWithoutProperties(config, _excluded);
  var requestConfig = _objectSpread({
    method: method
  }, rest);
  if (payload && (!isEmpty(payload) || payload instanceof FormData)) {
    requestConfig.data = payload;
  }
  if (params && !isEmpty(params)) {
    requestConfig.params = params;
  }
  if (headers) {
    requestConfig.headers = headers;
  }
  return requestConfig;
};